import { jsx } from "react/jsx-runtime";
import "./Grid-CcQKdsgp.js";
import { M as Markdown } from "./Markdown-B_ZQWLYf.js";
const textReactMarkdown = "_textReactMarkdown_oevns_1";
const textReactMarkdownLarge = "_textReactMarkdownLarge_oevns_9";
const textReactMarkdownMedium = "_textReactMarkdownMedium_oevns_278";
const textReactMarkdownSmall = "_textReactMarkdownSmall_oevns_290";
const styles = {
  textReactMarkdown,
  textReactMarkdownLarge,
  textReactMarkdownMedium,
  textReactMarkdownSmall
};
const Text = (props) => {
  const { className, content, size = "medium" } = props;
  let style = styles.textReactMarkdown;
  if (size === "large") {
    style += ` ${styles.textReactMarkdownLarge}`;
  }
  if (size === "medium") {
    style += ` ${styles.textReactMarkdownMedium}`;
  }
  if (size === "small") {
    style += ` ${styles.textReactMarkdownSmall}`;
  }
  return /* @__PURE__ */ jsx(Markdown, { ...props, className: `${style != null ? style : ""} ${className != null ? className : ""}`, children: content });
};
export {
  Text as T
};
